import {MessageCodes} from "../MessageCodes";
import ResultText from "../ResultText";
import ComparisonCSName from "../ComparisonCSName";
import EmptyLine from "../EmptyLine";
import {useUser} from "../../../context/UserContext";
import ResultView from "../../../components/ResultView";
import ResultTable from "../../../components/table/ResultTable";
import ResultHeader from "../../../components/table/ResultHeader";
import ResultRow from "../../../components/table/ResultRow";
import ResultHeaderCell from "../../../components/table/ResultHeaderCell";
import ResultBody from "../../../components/table/ResultBody";
import ResultBodyCell from "../../../components/table/ResultBodyCell";
import ResultCellHighlight from "../../../components/table/ResultCellHighlight";
import HecRasHelper from "../../../helpers/HecRasHelper";

export function C19({data, message_key}) {
    const {settings} = useUser()

    return (
        <>
            {
                data?.result?.map(row => (
                    <ResultView error_id={row?.error_id} message_key={message_key}>
                        <Description row={row} settings={settings} globalVariables={data?.global_variables} />
                    </ResultView>
                ))
            }
        </>
    )
}
const Description = ({text, row, settings, globalVariables}) => {
    switch (row.error_id) {
        case MessageCodes.Compare.SEC01.error_id: {
            return (
                <>
                    <ResultText>
                        There is cross section station reference adjustment at the following {row?.data?.length} cross sections. The adjustment values are listed on the table.
                        <EmptyLine />
                        <ResultTable data={row?.data?.map(r => ({csName: r.cross_section, csNameVal: r.cross_section}))}>
                            <ResultHeader>
                                <ResultRow>
                                    <ResultHeaderCell style={{textAlign: 'left'}}>River Station</ResultHeaderCell>
                                    <ResultHeaderCell style={{textAlign: 'left'}}>Adjustment (ft)</ResultHeaderCell>
                                </ResultRow>
                            </ResultHeader>
                            <ResultBody>
                                {
                                    row.data.map(r => (
                                        <ResultRow>
                                            <ResultBodyCell style={{textAlign: 'left', width: HecRasHelper.getWidth(15)}}><ComparisonCSName csName={r.cross_section} /></ResultBodyCell>
                                            <ResultBodyCell style={{textAlign: 'left', width: HecRasHelper.getWidth(15)}}>{r.adj}</ResultBodyCell>
                                        </ResultRow>
                                    ))
                                }
                            </ResultBody>
                        </ResultTable>
                        {row?.data?.map((x, index) => (
                            <ResultTable>

                            </ResultTable>
                        ))}
                    </ResultText>

                </>
            )
        }
        default: {
            return `Error Key Not Found: ${row.error_id}`
        }
    }
}